import React, { useEffect, useState } from "react"
import keyBy from "lodash/keyBy"
import {
  Datagrid,
  TextField,
  Pagination,
  Loading,
  ListContextProvider,
} from "react-admin"
import getHttpsCallable from "../../utils/getHttpsCallable"

const getBmwRegistrationTracking =
  getHttpsCallable("admin-listBmwRegistrationTracking")

export default function BmwRegistrationTrackingList () {
  const [page, setPage] = useState(1)
  const [data, setData] = useState<any[]>([])
  const [loading, setLoading] = useState(true)
  const [lastCreatedAts, setLastCreatedAts] = useState<any[]>([])
  const [total, setTotal] = useState(0)
  const perPage = 10

  async function fetchData (pageNumber: number) {
    setLoading(true)

    const paginationPayload: any = { pageSize: perPage }

    // Send lastCreatedAt for pagination if not on the first page
    if (pageNumber > 1 && lastCreatedAts[pageNumber - 2]) {
      paginationPayload.lastCreatedAt = lastCreatedAts[pageNumber - 2]
    }

    try {
      const result = await getBmwRegistrationTracking(paginationPayload)
      const fetchedData = result?.data?.data || []
      const lastCreatedAtFromResult = result?.data?.lastCreatedAt || null
      const hasMore = result?.data?.hasMore || false

      // Track the pagination cursor for next pages
      if (pageNumber === 1) {
        setLastCreatedAts([lastCreatedAtFromResult])
      } 
      else {
        const updated = [...lastCreatedAts]
        updated[pageNumber - 1] = lastCreatedAtFromResult
        setLastCreatedAts(updated)
      }

      setData(fetchedData)
      // Update total (just a simple estimation for react-admin pagination)
      setTotal(pageNumber * perPage + (hasMore ? 1 : 0))
    } 
    catch (err) {
      console.error("Error fetching BMW registration data:", err)
    } 
    finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    fetchData(page)
  }, [page])

  if (loading) return <Loading />

  const listData = data.map((item: any, idx: number) => ({
    ...item,
    id: item.createdAtDate || idx, // react-admin needs unique id
  }))

  const contextValue = {
    data: keyBy(listData, "id"),
    ids: listData.map(({ id }) => id),
    total,
    page,
    perPage,
    setPage,
    currentSort: { field: "createdAtDate", order: "DESC" },
    basePath: "/bmw-registration-tracking",
    selectedIds: [],
    resource: "bmw-registration-tracking",
    loading,
    loaded: !loading,
  }

  return (
    <ListContextProvider value={contextValue}>
      <div
        style={{
          width: "100%",
          overflowX: "auto",
          overflowY: "auto",
          maxHeight: "70vh",
          border: "1px solid #ddd",
          borderRadius: "8px",
        }}
      >
        <Datagrid rowClick="show" empty={<></>}>
          <TextField source="createdAtDate" label="Date" />
          <TextField source="totalUsers" label="Total Unique Users" />
          <TextField source="withUtm" label="With utm_source" />
          <TextField source="withoutUtm" label="Without utm_source" />
        </Datagrid>
      </div>
      <Pagination rowsPerPageOptions={[10, 20, 50]} />
    </ListContextProvider>
  )
}
